var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenwindow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9375 13.5332C22.3511 13.5332 21.8751 14.0103 21.8751 14.5956V21.8751H2.1248V2.1248H9.40316C9.99057 2.1248 10.4656 1.64886 10.4656 1.0624C10.4656 0.475944 9.99057 0 9.40316 0H1.0624C0.474996 0 0 0.475944 0 1.0624V22.9369C0 23.5243 0.474996 23.9993 1.0624 23.9993H22.9369C23.5243 23.9993 23.9993 23.5243 23.9993 22.9369V14.595C23.9996 14.0109 23.5246 13.5328 22.9372 13.5328L22.9375 13.5332Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9378 0.000364771H15.0632C14.4758 0.000364771 14.0008 0.476308 14.0008 1.06277C14.0008 1.64922 14.4758 2.12517 15.0632 2.12517H20.3731L11.9972 10.5011C11.5817 10.9166 11.5817 11.5879 11.9972 12.0034C12.2044 12.2107 12.4762 12.3148 12.7482 12.3148C13.0202 12.3148 13.2922 12.2107 13.4992 12.0034L21.8752 3.62746V8.93947C21.8752 9.52593 22.3511 10.0019 22.9376 10.0019C23.525 10.0019 24 9.52593 24 8.93947L24.0002 1.06252C24.0002 0.475119 23.5252 0.00012207 22.9378 0.00012207L22.9378 0.000364771Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenwindow);
export default __webpack_public_path__ + "static/media/openwindow.a3c705c585df6619a1e49a350fec4f22.svg";
export { ForwardRef as ReactComponent };